import styled, { keyframes, css } from 'styled-components';

const height = `8px`;

export const Slider = styled.div`
  position: relative;
  width: 100%;
  height: ${height};
  overflow-x: hidden;
`;

export const Line = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.palette.lightBackground};
  width: 120%;
  height: ${height};
`;

const slide = keyframes`
  from {
    transform: translateX(-80%) scaleX(0.8);
  }
  to {
    transform: translateX(110%) scaleX(0.1);
  }
`;

const animation = () =>
  css`
    ${slide} 1.8s infinite;
  `;

export const SubLine = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.palette.border};
  width: 100%;
  height: ${height};
  animation: ${animation};
`;
